import Addr from './getAPI'
import { Toast } from "mint-ui";
// import router from "@/router/index";

export default {
  open: (link) => {
    try {
      mui.openWindow(Addr.getAliYunAddr() + "detail.html?link=" + link);
    } catch (error) {
      console.log("no mui");
      window.location.href=link;
    }
  },
  openInExplorer: (link) => {
    //window.location.href=link;
    
    // router.push({
    //   path: "/link",
    //   query: {
    //     link: link
    //   }
    // });

    //return;

    // window.location.href="protocol://android?link="+link;
    // return;

    try {
      plus.runtime.openURL(link, error => {
        // Handle the error
        Toast({
          message: "浏览器打开全景地址出现异常错误",
          position: "bottom",
          duration: 800
        });
        console.log("explorer style error!");
      });
    } catch (error) {
      console.log("no plus");
      window.location.href=link;
    }
  }
}




// WEBPACK FOOTER //
// ./src/utils/openUrl.js